import { render, staticRenderFns } from "./CardDesign.vue?vue&type=template&id=ebaba91e"
import script from "./CardDesign.vue?vue&type=script&lang=ts"
export * from "./CardDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports